const texts = {
    'documents': ['app/documents', 'cmp/document'],
    'sales': [
        'app/sales',
        'cmp/product',
        'cmp/contact',
        'cmp/select',
        'cmp/invoice',
        'cmp/stockShipment'
    ],
    'crm': [
        'app/crm',
        'cmp/contact',
        'cmp/product',
        'cmp/select'
    ],
    'service': ['app/service', 'cmp/contact', 'cmp/product', 'cmp/select', 'cmp/employee'],
    'home': ['app/home', 'cmp/select'],
    'org': ['app/org', 'cmp/select'],
    'entry': ['app/entry', 'cmp/select'],
    'hello': ['app/hello', 'cmp/select'],
    'inventory': ['app/inventory', 'cmp/product', 'cmp/contact', 'cmp/stockShipment', 'cmp/warehouseOrder', 'cmp/select', 'cmp/document'],
    'warehouse': ['app/warehouse', 'cmp/warehouseOrder', 'cmp/select', 'cmp/product','app/inventory'],
    'purchases': ['app/purchases', 'cmp/product', 'cmp/contact', 'cmp/select', 'cmp/document'],
    'bank': ['app/bank', 'cmp/contact', 'cmp/invoice'],
    'portal': ['app/portal'],
    'admin': ['app/admin', 'cmp/employee'],
    'project': ['app/project', 'app/admin', 'cmp/employee', 'cmp/invoice', 'cmp/product', 'cmp/contact', 'cmp/select'],
    'manufacturing': ['app/manufacturing', 'app/inventory', 'cmp/product', 'cmp/select', 'cmp/document'],
    'accounting': ['app/accounting', 'cmp/document'],
    'studio': ['app/studio', 'cmp/select'],
}

export default texts